import React, { useState } from "react";
import {
  Row,
  Col,
} from "reactstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { formattedDate, formattedDateTime, getBookingStatus, hasSlotStarted } from "../../helpers/Helper";
import filterFactory, { selectFilter, textFilter, dateFilter } from 'react-bootstrap-table2-filter';
import { useNavigate } from "react-router-dom";
import TableNoDataIndication from "../common/TableNoDataIndication";
import { BookingStatusText, BookingStatusWithID } from "../../constants/bookingStatus";

const { SearchBar } = Search;
const BookingList = ({
  bookings,
  loading,
  setIsAddMode,
  setSelectedRow,
  setModal
}) => {
  const navigate = useNavigate();
  const [selectedStatus, setSelectedStatus] = useState('all');

  const afterSearch = (newResult) => {
    console.log(newResult);
  };
  const selectOptions = BookingStatusText;
  const tblColumn = [
    {
      dataField: 'sr_no',
      text: 'Sr.No.',
      // formatter: (value, row, index) => {
      //     return (<>{index + 1}</>)
      // }
    },
    {
      dataField: "xray_booking_id",
      text: "Booking Id",
      sort: true,
      // filter: textFilter()
    },
    {
      dataField: "user",
      text: "App User",
      sort: true,
      formatter: (value, row) => {
        return (
          <span
            onClick={() => navigate(`/user-info/${row.user_id._id}`)}
            style={{ cursor: 'pointer' }}
          >
            {row.user_id.name || 'N/A'}
          </span>
        );
      }
    },
    {
      dataField: "patent_name",
      text: "Patient Name",
      sort: true,
      // filter: textFilter()
    },
    {
      dataField: "booking_date",
      text: "Booking Date",
      sort: true,
      formatter: (value, row) => {
        return <span>{formattedDateTime(row.booking_date)}</span>;
      },

    },
    {
      dataField: "xray_type_name",
      text: "X-ray Type",
      sort: false,
    },
    {
      dataField: "inves_report_opted",
      text: "Investigation Report",
      sort: false,
      formatter: (cell) => cell ? 'Yes' : 'No'
    },
    {
      dataField: "booking_amount",
      text: "Fee Charged",
      sort: true,
      formatter: (cell) => cell ? `${cell}` : 'N/A'
    },
    {
      dataField: "appointment_date",
      text: "Appointment Date",
      sort: true,
      // formatter: (value, row) => {
      //   return <span>{formattedDate(row.appointment_date)}</span>;
      // },
      // filter: dateFilter({
      //   delay: 400,
      //   placeholder: 'custom placeholder',
      //   withoutEmptyComparatorOption: true,
      //   // comparators: [Comparator.EQ, Comparator.GT, Comparator.LT],
      //   style: { display: 'inline-grid' },
      //   className: 'custom-datefilter-class',
      //   comparatorStyle: { backgroundColor: 'antiquewhite',display:'none' },
      //   comparatorClassName: 'custom-comparator-class',
      //   // dateStyle: { backgroundColor: 'cadetblue', margin: '0px'},
      //   dateClassName: 'custom-date-class'
      // })
    },
    {
      dataField: "appointment_slot",
      text: "Appointment Slot",
      sort: true,
    },
    {
      dataField: 'booking_status_id',
      text: 'Booking Status',
      formatter: cell => selectOptions[cell]
    }, {
      dataField: '',
      text: 'Action',
      formatter: (value, row) => {
        const canAssignCenter = row.booking_status_id === BookingStatusWithID.BOOKING_GENERATED
          && hasSlotStarted(row.appointment_date, row.appointment_slot);
        return (
          <span className="d-flex align-items-center">
            <span onClick={() => { navigate(`/view-booking-detail/${row._id}`) }}><i className="lni lni-eye font-size-16 me-1" /></span>
            {canAssignCenter && (
              <button
                type="button"
                className="btn btn-sm btn-primary ms-2"
                onClick={() => {
                  setSelectedRow(row);
                  setIsAddMode('Edit');
                  setModal(true);
                }}
              >
                Assign Center
              </button>
            )}
          </span>
        );
      },
    }
  ];

  const defaultSorted = [
    {
      dataField: "_id",
      order: "desc",
    },
  ];

  // Filter bookings based on selected status
  const filteredBookings = selectedStatus === 'all'
    ? bookings
    : bookings.filter(booking => booking.booking_status_id === parseInt(selectedStatus));

  const pzipcodeOptions = {
    sizePerPzipcode: 10,
    totalSize: filteredBookings.length, // replace later with size(customers),
    custom: true,
  };
  return (
    <React.Fragment>
      <PaginationProvider
        pagination={paginationFactory(pzipcodeOptions)}
        keyField="id"
        columns={tblColumn}
        data={filteredBookings}
      >
        {({ paginationProps, paginationTableProps, }) => (

          <ToolkitProvider keyField="_id" columns={tblColumn} data={filteredBookings} search={{ afterSearch }}>
            {(toolkitProps) => (
              <React.Fragment>
                <Row className="mb-2" style={{ display: "none" }}>
                  <Col md="4">
                    <div className="search-box me-2 mb-2 d-inline-block">
                      <div className="status-relative"></div>
                    </div>
                  </Col>
                </Row>
                <Row className="mb-3">
                  <Col xl="12">
                    <div className="d-flex justify-content-end align-items-center gap-3">
                      {/* Booking Status Dropdown */}
                      <div className="d-flex align-items-center">
                        <label className="pe-2 mb-0 text-nowrap">Booking Status:</label>
                        <select
                          className="form-select form-select-sm"
                          style={{ minWidth: '200px' }}
                          value={selectedStatus}
                          onChange={(e) => setSelectedStatus(e.target.value)}
                        >
                          <option value="all">All Bookings</option>
                          {Object.entries(BookingStatusText).map(([id, label]) => (
                            <option key={id} value={id}>{label}</option>
                          ))}
                        </select>
                      </div>
                      {/* Search Bar */}
                      <div className="d-flex align-items-center">
                        <label className="mb-0">Search:</label>
                        <SearchBar className="form-control form-control-sm" style={{ minWidth: '250px' }} {...toolkitProps.searchProps} />
                      </div>
                    </div>
                    <div className="table-responsive mt-3">
                      <BootstrapTable
                        noDataIndication={<TableNoDataIndication loading={loading} />}
                        keyField={"id"}
                        responsive
                        bordered={false}
                        striped={false}
                        defaultSorted={defaultSorted}
                        classes={
                          "table table-striped align-middle table-nowrap"
                        }
                        headerWrapperClasses={"thead-light"}
                        {...toolkitProps.baseProps}
                        {...paginationTableProps}
                        filter={filterFactory()}
                      />
                    </div>
                  </Col>
                </Row>
                {filteredBookings.length > 0 && (
                  <Row className="align-items-md-center mt-30">
                    <Col className="inner-custom-pagination mt-2 d-flex">
                      <div className="d-inline">
                        <SizePerPageDropdownStandalone {...paginationProps} />
                      </div>
                      <div className="text-md-right ms-auto">
                        <PaginationListStandalone {...paginationProps} />
                      </div>
                    </Col>
                  </Row>
                )}
              </React.Fragment>
            )}
          </ToolkitProvider>
        )}
      </PaginationProvider>
    </React.Fragment >
  );
};

export default BookingList;
